export const SAVE_CHAT_ANSWERS = 'SAVE_CHAT_ANSWERS';
export const SAVE_PROPOSAL = 'SAVE_PROPOSAL';
